export default __webpack_public_path__ + "static/media/OwlPage2.8400f48c.txt";